import { isValidFullPhone } from '../phone';

// Validadores comunes centralizados
export const isEmail = (email: string | null | undefined): boolean => {
  if (!email) return false;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

export const isPhone = (phone: string | null | undefined): boolean => {
  if (!phone) return false;
  return isValidFullPhone(phone);
};

export const isUrl = (url: string | null | undefined): boolean => {
  if (!url) return false;

  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const isNotEmpty = (value: string | number | null | undefined): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim().length > 0;
  if (typeof value === 'number') return !isNaN(value);
  return true;
};

export const isNumber = (value: string | number | null | undefined): boolean => {
  if (value === null || value === undefined) return false;

  const numericValue = typeof value === 'string' ? parseFloat(value) : Number(value);
  return !isNaN(numericValue) && isFinite(numericValue);
};

export const isPositiveNumber = (value: string | number | null | undefined): boolean => {
  if (!isNumber(value)) return false;

  const numericValue = typeof value === 'string' ? parseFloat(value) : Number(value);
  return numericValue > 0;
};

export const isInteger = (value: string | number | null | undefined): boolean => {
  if (!isNumber(value)) return false;

  const numericValue = typeof value === 'string' ? parseFloat(value) : Number(value);
  return Number.isInteger(numericValue);
};

export const isPositiveInteger = (value: string | number | null | undefined): boolean => {
  if (!isInteger(value)) return false;

  const numericValue = typeof value === 'string' ? parseFloat(value) : Number(value);
  return numericValue > 0;
};

export const isInRange = (value: number, min: number, max: number): boolean => {
  return value >= min && value <= max;
};

export const hasMinLength = (text: string | null | undefined, minLength: number): boolean => {
  if (!text) return false;
  return text.trim().length >= minLength;
};

export const hasMaxLength = (text: string | null | undefined, maxLength: number): boolean => {
  if (!text) return true;
  return text.trim().length <= maxLength;
};

export const hasLength = (text: string | null | undefined, length: number): boolean => {
  if (!text) return false;
  return text.trim().length === length;
};

export const isAlphanumeric = (text: string | null | undefined): boolean => {
  if (!text) return false;

  const alphanumericRegex = /^[a-zA-Z0-9]+$/;
  return alphanumericRegex.test(text);
};

export const isAlpha = (text: string | null | undefined): boolean => {
  if (!text) return false;

  const alphaRegex = /^[a-zA-Z\s]+$/;
  return alphaRegex.test(text);
};

export const isNumeric = (text: string | null | undefined): boolean => {
  if (!text) return false;

  const numericRegex = /^[0-9]+$/;
  return numericRegex.test(text);
};
